import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CreateUserConvo } from './CreateUserConvo';

interface CreateUserConvoModalProps {
  buttonLabel?: string;
  recipientUserId?: string;
  subjectText?: string;
}

export const CreateUserConvoModal = (props: CreateUserConvoModalProps) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <Button variant="primary" size="sm" onClick={() => setShowModal(true)}>
        {props.buttonLabel || 'Create a new Conversation'}
      </Button>
      {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          aria-labelledby="ref-value-picker-modal-title"
          size="xl"
          fullscreen="xl-down"
        >
          <Modal.Header closeButton>
            <Modal.Title id="ref-value-picker-modal-title">
              {props.buttonLabel || 'Create a new Conversation'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateUserConvo
              onSent={() => setShowModal(false)}
              allowChangeRecipient={false}
              recipientUserId={props.recipientUserId}
              subjectText={props.subjectText}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
